import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/inventario/importer/inventarioImporterActions';

export default importerReducers(actions);
